import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {useDispatch, useSelector} from "react-redux";
import BusinessIcon from '@material-ui/icons/Business';
import AddIcon from '@material-ui/icons/Add';
import ClientInfoCardForManagers from '../../../../../components/customBreachBits/admin/TabbedClientInfoCardForManagers';
import {bbErrorSection} from "../../../../../util/bbHelpers";
import {fetchCustomers} from "../../../../../actions";
import NewClientForm from "../../../../../containers/NewClientForm";
import CircularProgress from "../../../../../components/prefabricated/CircularProgress";
import BRCustomersTable from "../../../../../components/customBreachBits/admin/BRCustomersTable/BRCustomersTable";
import {Box} from "@material-ui/core";
import {NavLink, Route, Switch} from "react-router-dom";
import Dashboard from "../Dashboard";
import AllEntitiesPage from "./AllEntitiesPage";
import CustomerDashboard from "./CustomerDashboard";

function TabContainer({children, dir}) {
    return (
        <div dir={dir} style={{padding: 8 * 3}}>
            {children}
        </div>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

const LinkTab =(props) =>{
    return (
        <Tab
            // component="a"
            onClick={(event) => {
                event.preventDefault();
            }}
            {...props}
        />
    );
}

function PageRoutes({match}){
    return(
        <Switch>
            <Route exact={true} path={`${match.url}`} component={CustomerDashboard}/>
            <Route path={`${match.url}/entities`} component={AllEntitiesPage}/>
            <Route path={`${match.url}/customers`} component={BRCustomersTable}/>
            <Route path={`${match.url}/addCustomers`} component={NewClientForm}/>
        </Switch>
    )
}

const TabBoard = ({match}) => {

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers} = useSelector(({customer}) => customer);
    const {loadingCustomers, loadingCustomersError} = useSelector(({customer}) => customer);
    const numCustomers = customers ? Object.keys(customers).length : null;

    const [value, setValue] = useState(0);
    const [customerArray, setCustomerArray] = useState([]);
    const dispatch = useDispatch();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect( () => {
        if (customers && numCustomers) {
            //if the customers are loaded, then populate the customerArray
            setCustomerArray(Object.keys(customers));
        }

        if (customers == null || !numCustomers) {
            // console.log("Customers is empty, fetching.")
            dispatch(fetchCustomers());
        }
    }, [customers, dispatch, numCustomers]);

    /**************************/
    /*End State and Dispatch*/
    /**************************/


    // const {theme} = props;

        return (
            <div className={"animated animated fadeIn animation-duration-7"}>
                <div className="app-main-menu d-none d-md-block text-center border border-dark bg-dark">
                    <ul className="navbar-nav navbar-nav-mega">
                        <li className="nav-item">
                            <NavLink to={'/board/admin/clients/'}>
                                <span className="nav-text">Clients</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to={'/board/admin/clients/entities'}>
                                <span className="nav-text">Entities</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to={'/board/admin/clients/customers'}>
                                <span className="nav-text">Customers</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to={'/board/admin/clients/addCustomers'}>
                                <span className="nav-text">Add Customer</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
                <PageRoutes match={match}/>
            </div>


            // <div className="animated animated fadeIn animation-duration-7">
            //     <AppBar position="static" color="default">
            //         <Tabs
            //             value={value}
            //             onChange={(event, newValue) => setValue(newValue)}
            //             indicatorColor="primary"
            //             textColor="primary"
            //             variant="fullWidth"
            //             scrollButtons="on"
            //         >
            //             <LinkTab className="tab" label="BreachRisk Clients" href={'/board/admin/customers'} component={BRCustomersTable}/>
            //             {/*<LinkTab className="tab" label="Clients" href={'/board/admin/entities'} component={}/>*/}
            //             <LinkTab className="tab" label="Add Client" href={'board/admin/addCustomer'} component={NewClientForm}/>
            //
            //         </Tabs>
            //     </AppBar>
            //      <SwipeableViews
            //         axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            //         index={value}
            //         onChangeIndex={(event, newValue) => setValue(newValue)}
            //     >
            //         <TabContainer dir={theme.direction}>
            //             <BRCustomersTable/>
            //         </TabContainer>
            //
            //         <TabContainer dir={theme.direction}>
            //             <div className="row">
            //             {!loadingCustomers && !loadingCustomersError && customers &&
            //                     customerArray.map(customerId => <ClientInfoCardForManagers key ={`${customerId}_mgrinfocrd`} customerOverride={customerId}/>)
            //             }
            //             {loadingCustomers && !loadingCustomersError &&
            //                 <CircularProgress/>
            //             }
            //             {loadingCustomersError &&
            //             bbErrorSection()
            //             }
            //             </div>
            //         </TabContainer>
            //
            //         <TabContainer dir={theme.direction}>
            //             <NewClientForm/>
            //         </TabContainer>
            //     </SwipeableViews>
            //  </div>
        );

}

TabBoard.propTypes = {
    theme: PropTypes.object.isRequired,
};

export default withStyles(null, {withTheme: true})(TabBoard);